import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
    addNewDirectBillingData,
  deleteDirectBilling,
  fetchDirectBillingDatas,
  updateDirectBilling,
} from "../thunks/directBilling";

import type { DirectBilling } from "../../utils/types/directBilling";

interface DockageFeeListState {
  directBillingList: DirectBilling[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: DockageFeeListState = {
  directBillingList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const directBillingListSlice = createSlice({
  name: "directBilling",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDirectBillingDatas.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchDirectBillingDatas.fulfilled, (state, action) => {
        state.directBillingList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchDirectBillingDatas.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updateDirectBilling.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDirectBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.directBillingList = state.directBillingList.map((list) => {
          if (
            list.directBillingAssignmentId ===
            action.payload?.directBillingAssignmentId
          ) {
            return { ...list, ...action.payload };
          }
          return list;
        });
      })
      .addCase(updateDirectBilling.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteDirectBilling.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDirectBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.directBillingList = state.directBillingList.filter(
          (list) => list.directBillingAssignmentId !== action.payload?.id
        );
      })
      .addCase(deleteDirectBilling.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewDirectBillingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewDirectBillingData.fulfilled, (state, action) => {
        state.loading = false;
        state.directBillingList = [action.payload, ...state.directBillingList];
      })
      .addCase(addNewDirectBillingData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
       addWebSocketCases(builder, "directBilling", "directBillingList");
  },
});

export const { resetDataFetched } = directBillingListSlice.actions;
export default directBillingListSlice.reducer;
